import { ojs, app, each, v } from "modular-openscriptjs";
import { either, oneOf } from "../helpers";
import Navigation from "./Navigation";
import { gc, PAGES } from "../declarations";

const h = app("h");
const uc = app("uc");

export default class BottomNav extends Navigation {
	name = "BottomNav";

	/**
	 * Parse a nav item
	 * @param {NavItem} item
	 */
	parseItem(item, ...args) {
		return h.li(
			{
				class: "nav-item",
				app_hook: "app-nav",
				app_nav_hook: item.appHook,
				role: "button",
				onclick: item.onclick,
			},
			h.a(
				{
					class: "nav-link text-center",
					role: "button",
					href: "javascript:void(0);",
				},
				oneOf(item.middleAttrs),

				h.span(
					{
						class: "icon",
					},
					item.icon(),
				),

				h.small({ class: "text m-0" }, item.text),

				either(item.children.length > 0, {
					class: "nav-link",
					role: "button",
					data_bs_toggle: "dropdown",
					aria_expanded: "false",
				}),
			),
			either(item.children.length > 0, { class: "dropdown" }),
			this.dropdown(item.children),
			...args,
		);
	}

	/**
	 *
	 * @param {NavItem[]} items
	 */
	renderNav(items) {
		let lis = [];

		for (let i = 0; i < items.length; i++) {
			let nav = items[i];
			lis.push(
				this.parseItem(
					nav,
					{ page_name: nav.pageName },
					this.activate(nav),
				),
			);
		}

		return lis;
	}

	render(items, ...args) {
		if (!gc.auth.value) return h.empty();

		return h.div(
			{
				class: "container-xl",
				$class: "d-block d-md-none bottom-navbar fixed-bottom",
			},
			h.ul({ class: "bottom-navbar-list" }, this.renderNav(items.value)),
			...args,
		);
	}
}
